<template>
  <div class="product-header">
    <i class="iconfont icon-home"/> All Products
  </div>
  <product-list :product="products"/>
</template>

<script setup lang="ts">
import {products} from "~/data/data"
import ProductList from "~/components/product-list.vue"

const allProducts = computed(() => {

})
</script>

<style lang="stylus" scoped>
.product-header
  height 30px
  box-sizing border-box
  border-bottom 1px solid #EEE
  color #1e8bac
  font-size 16px
  display flex
  align-items top
  .icon-home
    margin-right 8px
    color #888
</style>
